import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  AfterViewChecked,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Subscription, finalize, map } from 'rxjs';
import { ActivatedRoute, Data, Router } from '@angular/router';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Account } from 'app/core/models';
import { AccountService } from 'app/core';
import { TaskListTemplate } from 'app/shared/modules/legacy-tasks/tasks.types';
import { LegacyTasksTabService } from '@shared/modules/legacy-tasks/services/tasks.service';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { ProjectTemplate } from 'app/modules/projects/projects.types';

@Component({
  selector: 'settings-layouts-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsLayoutsListComponent extends OnDestroyMixin implements OnInit, AfterViewChecked {
  public layoutsCount: number;
  public layoutsTableColumns: string[] = ['name', 'related_to_type', 'created_at', 'updated_at'];
  public dataSource: MatTableDataSource<ProjectTemplate<any>>;
  public projectTemplates: ProjectTemplate<any>[];

  private sortApplied: boolean = false;

  @ViewChild(MatSort) private sort: MatSort;

  private get account(): Account {
    return this.accountService.getCurrentAccount();
  }

  constructor(
    private readonly matDialog: MatDialog,
    private readonly cdRef: ChangeDetectorRef,
    private readonly accountService: AccountService,
    private readonly tasksService: LegacyTasksTabService,
    private readonly snackBar: MatSnackBar,
    private _activatedRoute: ActivatedRoute,
    private _accountService: AccountService,
    private _projectsService: ProjectsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this._activatedRoute.data.subscribe((data: Data) => {
      this.projectTemplates = data.options.project_templates.sort((a, b) => a.rank - b.rank);
      this.dataSource = new MatTableDataSource<ProjectTemplate<any>>(this.projectTemplates);
      this.layoutsCount = this.projectTemplates.length;
    });
  }

  ngAfterViewChecked(): void {
    this.applySortToDataSource();
  }

  // Check if the MatSort has been applied and apply it if not
  public applySortToDataSource(): void {
    if (this.dataSource && this.sort && !this.sortApplied) {
      this.dataSource.sort = this.sort;
      this.sortApplied = true;
    }
  }

  public trackByFn(index: number, item: TaskListTemplate): number {
    return item.id || index;
  }

  public getRelatedToType(rawValue: string): string {
    switch (rawValue) {
      case 'Project':
        return 'Deal';
      case 'PropertyTenant':
        return 'Lease';
      case 'PropertyUnit':
        return 'Unit';
      case 'Account':
        return 'Global';
      default:
        return rawValue;
    }
  }
}
